import styled, { css } from 'styled-components';
import { Box, Widget } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';
import { ProgressContent } from '@scope/scope-one-ui/core/ProgressBar/ProgressBar.styled';
import { RadioWidgetProps } from './EsgEventsCard.d';

export const WidgetContent = styled(Box)`
  transition: 0.2s ease-out;
`;

export const RadioWidget = styled(Widget)<RadioWidgetProps>(
  ({ active }) => css`
    cursor: ${!active && 'pointer'};
    flex: 1;

    ${WidgetContent} {
      background-color: ${!active && COLORS.background.control};

      > :last-child {
        transition: 0.2s ease-out;
        opacity: ${active ? 1 : 0};
        pointer-events: ${!active && 'none'};
      }
    }

    ${ProgressContent} {
      background-color: ${!active && COLORS.secondary.pressed};
    }
  `,
);
